import { TableCell } from "@mui/material";
import React from "react";
import style from "./table.module.css";
import { icon, IconComponent } from "../../../../common/components";

export default function HeadCell({ onClick, cell, className, hiddenSort }) {
	return (
		<TableCell
			align="left"
			className={`${style.tableCellHead} ${className} ${hiddenSort ? style.noCursor : ""}`}
			onClick={onClick}
		>
			<span>
				{cell.name}{" "}
				{!hiddenSort && (
					<IconComponent className={style.tableCellHeadIcon} fontSize="default" icon={icon.faSort} />
				)}
			</span>
		</TableCell>
	);
}
